import { Navigate, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { ROUTES } from '@shared/config/routes';
import { BuyRequestDetail } from '@features/rfq-detail';

export function BuyRequestDetailPage() {
  const { t } = useTranslation();
  const { id } = useParams<{ id: string }>();
  if (!id) return <Navigate to={ROUTES.buyRequests} replace />;
  return (
    <div className="flex flex-col gap-6">
      <header>
        <h1 className="text-2xl font-semibold">{t('buyRequests.detail.title')}</h1>
        <p className="text-sm opacity-70">{t('buyRequests.detail.subtitle')}</p>
      </header>
      <BuyRequestDetail id={id} />
    </div>
  );
}
